module.exports = __webpack_public_path__ + "img/br25.d9f010e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br25.jpg
// module id = Z28u
// module chunks = 0